export default {
  methods: {
    trackStartSection() {
      this.ga_send_event(this.auth, {
        eventCategory: 'academic',
        eventAction: 'start_section',
      });
    },
    trackEndSection() {
      this.ga_send_event(this.auth, {
        eventCategory: 'academic',
        eventAction: 'end_section',
      });
    },
    trackSubmitPresence() {
      this.ga_send_event(this.auth, {
        eventCategory: 'academic',
        eventAction: 'submit_presence',
      });
    },
    trackSubmitPresenceGeneralClass() {
      this.ga_send_event(this.auth, {
        eventCategory: 'general_classes',
        eventAction: 'submit_presence',
      });
    },
    trackSubmitStudyRealization() {
      this.ga_send_event(this.auth, {
        eventCategory: 'academic',
        eventAction: 'submit_study_relization',
      });
    },
    trackSubmitAssignmentGrade(feedback = false) {
      let eventAction = feedback ? 'submit_assignment_grade_with_feedback' : 'submit_assignment_grade';
      this.ga_send_event(this.auth, {
        eventCategory: 'assignment',
        eventAction,
      });
    }
  }
}
